// extracted by mini-css-extract-plugin
export default {"NoteForm":"NoteForm_NoteForm__AfFEJ"};